import { cn } from "@/lib/utils";

interface DropdownItemProps {
  icon?: any;
  data: any;
  setSelected: (data: any) => void;
  selectedData: any;
  onClose: () => void;
  loading: boolean;
  multipleSelect?: boolean;
}

export default function DropdownItem(props: DropdownItemProps) {
  const { icon, data, loading, multipleSelect, selectedData } = props;

  const getExistedData = (data: any) => {
    if (!multipleSelect) return false;
    return selectedData?.find((item: any) => item.id === data.id);
  };

  return (
    <button
      role="option"
      aria-selected={selectedData?.id == data?.id}
      aria-disabled={loading || !!getExistedData(data)}
      disabled={loading || !!getExistedData(data)}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();

        props.setSelected(data);
        if (!multipleSelect) {
          // if the not multiple select then close the dropdown
          props.onClose();
        }
      }}
      key={data.id}
      className={cn(
        `py-2 flex items-center gap-2 w-full`,
        loading || !!getExistedData(data) ? "cursor-not-allowed" : "",
      )}
    >
      {icon && <props.icon className="size-4"></props.icon>}
      <span>{data.title}</span>
    </button>
  );
}
